"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const i0 = require("@angular/core");
const i1 = require("@angular/forms");
const i2 = require("@angular/common");
const i3 = require("./email-validator.directive");
const _c0 = ["emailForm"];
function DnaREmailInput_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("Email address for ", ctx_r1.requiredFor.toLowerCase(), " required");
} }
function DnaREmailInput_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1, "Email address is required");
    i0.ɵɵelementEnd();
} }
function DnaREmailInput_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("Email address must not exceed ", ctx_r3.validLength, " characters");
} }
function DnaREmailInput_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1, "Email must contain @ symbol");
    i0.ɵɵelementEnd();
} }
function DnaREmailInput_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1, "Email must not contain multiple @ symbol");
    i0.ɵɵelementEnd();
} }
function DnaREmailInput_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1, "Email must not contain special characters");
    i0.ɵɵelementEnd();
} }
function DnaREmailInput_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1, "Email must contain domain name");
    i0.ɵɵelementEnd();
} }
function DnaREmailInput_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1, "Email must contain domain extension e.g. .com");
    i0.ɵɵelementEnd();
} }
function DnaREmailInput_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1, "Email must not contain spaces");
    i0.ɵɵelementEnd();
} }
function DnaREmailInput_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1, "Email address must follow proper format");
    i0.ɵɵelementEnd();
} }
function DnaREmailInput_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1, "Email address must be unique");
    i0.ɵɵelementEnd();
} }
const _c1 = function (a0, a1) { return { invalid: a0, valid: a1 }; };
class DnaREmailInput {
    constructor() {
        this.placeholder = "";
        this.id = "";
        this.name = "";
        this.value = "";
        this.required = false;
        this.class = "";
        // This property "requiredFor" is used to show required validation for. Ex. Email is required for "primary contact"
        this.requiredFor = "";
        this.emailsToCompare = "";
        this.valueChange = new core_1.EventEmitter();
        this.childEvent = new core_1.EventEmitter();
        this.triggerUniqueValidation = false;
        this.triggerCcEmailLengthValidation = false;
    }
    ngOnChanges(changes) {
        if (changes.triggerUniqueValidation && changes.triggerUniqueValidation.currentValue) {
            this.makeEmailFormValid("duplicateEmail"); // Make form valid if triggered
        }
        if (changes.triggerCcEmailLengthValidation && changes.triggerCcEmailLengthValidation.currentValue) {
            this.makeEmailFormValid("invalidCCEmailLength"); // Make form valid if triggered
        }
    }
    onValueChange(newValue) {
        this.value = newValue;
        this.valueChange.emit(this.value);
    }
    onCustomEvent(event) {
        // Re-emit the event to the great parent component
        this.childEvent.emit(event);
    }
    makeEmailFormValid(errorKey) {
        if (this.emailForm) {
            Object.keys(this.emailForm.controls).forEach((key) => {
                const control = this.emailForm.controls[key];
                if (control.errors && control.errors[errorKey]) {
                    const errors = Object.assign({}, control.errors); // Copy the errors object
                    delete errors[errorKey]; // Remove the specific 'duplicateEmail' error
                    if (Object.keys(errors).length === 0) {
                        control.setErrors(null); // If no errors left, clear all errors
                    }
                    else {
                        control.setErrors(errors); // Otherwise, set the remaining errors
                    }
                    control.markAsPristine();
                    control.markAsUntouched();
                }
            });
        }
    }
}
exports.DnaREmailInput = DnaREmailInput;
DnaREmailInput.ɵfac = function DnaREmailInput_Factory(t) { return new (t || DnaREmailInput)(); };
DnaREmailInput.ɵcmp = i0.ɵɵdefineComponent({ type: DnaREmailInput, selectors: [["dna-r-email-input"]], viewQuery: function DnaREmailInput_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.emailForm = _t.first);
    } }, inputs: { placeholder: "placeholder", id: "id", unique: "unique", name: "name", value: "value", required: "required", class: "class", saveForm: "saveForm", requiredFor: "requiredFor", validLength: "validLength", totalValidLength: "totalValidLength", emailsToCompare: "emailsToCompare", triggerUniqueValidation: "triggerUniqueValidation", triggerCcEmailLengthValidation: "triggerCcEmailLengthValidation" }, outputs: { valueChange: "valueChange", childEvent: "childEvent" }, features: [i0.ɵɵNgOnChangesFeature], decls: 15, vars: 28, consts: [["emailForm", "ngForm"], [1, "dnaRComponent", "dnaRInput", 3, "ngClass"], ["type", "email", "emailValidator", "", 3, "id", "name", "ngModel", "placeholder", "required", "unique", "emailsToCompare", "saveForm", "validLength", "totalValidLength", "ngModelChange", "customEvent"], ["class", "error", 4, "ngIf"], [1, "error"]], template: function DnaREmailInput_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", null, 0);
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵelementStart(3, "input", 2);
        i0.ɵɵlistener("ngModelChange", function DnaREmailInput_Template_input_ngModelChange_3_listener($event) { return ctx.value = $event; })("ngModelChange", function DnaREmailInput_Template_input_ngModelChange_3_listener($event) { return ctx.onValueChange($event); })("customEvent", function DnaREmailInput_Template_input_customEvent_3_listener($event) { return ctx.onCustomEvent($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, DnaREmailInput_div_4_Template, 2, 1, "div", 3);
        i0.ɵɵtemplate(5, DnaREmailInput_div_5_Template, 2, 0, "div", 3);
        i0.ɵɵtemplate(6, DnaREmailInput_div_6_Template, 2, 1, "div", 3);
        i0.ɵɵtemplate(7, DnaREmailInput_div_7_Template, 2, 0, "div", 3);
        i0.ɵɵtemplate(8, DnaREmailInput_div_8_Template, 2, 0, "div", 3);
        i0.ɵɵtemplate(9, DnaREmailInput_div_9_Template, 2, 0, "div", 3);
        i0.ɵɵtemplate(10, DnaREmailInput_div_10_Template, 2, 0, "div", 3);
        i0.ɵɵtemplate(11, DnaREmailInput_div_11_Template, 2, 0, "div", 3);
        i0.ɵɵtemplate(12, DnaREmailInput_div_12_Template, 2, 0, "div", 3);
        i0.ɵɵtemplate(13, DnaREmailInput_div_13_Template, 2, 0, "div", 3);
        i0.ɵɵtemplate(14, DnaREmailInput_div_14_Template, 2, 0, "div", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(25, _c1, !_r0.valid && ((_r0.controls[ctx.name] == null ? null : _r0.controls[ctx.name].touched) || ctx.saveForm.$submitted), _r0.valid));
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("input ", ctx.class, "");
        i0.ɵɵproperty("id", ctx.id)("name", ctx.name)("ngModel", ctx.value)("placeholder", ctx.placeholder)("required", ctx.required)("unique", ctx.unique)("emailsToCompare", ctx.emailsToCompare)("saveForm", ctx.saveForm)("validLength", ctx.validLength)("totalValidLength", ctx.totalValidLength);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (_r0.controls[ctx.name] == null ? null : _r0.controls[ctx.name].errors == null ? null : _r0.controls[ctx.name].errors.emailrequired) && ctx.requiredFor && (ctx.saveForm.$submitted || ctx.saveForm[ctx.name] && ctx.saveForm[ctx.name].$touched));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (_r0.controls[ctx.name] == null ? null : _r0.controls[ctx.name].errors == null ? null : _r0.controls[ctx.name].errors.emailrequired) && !ctx.requiredFor && (ctx.saveForm.$submitted || ctx.saveForm[ctx.name] && ctx.saveForm[ctx.name].$touched));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", _r0.controls[ctx.name] == null ? null : _r0.controls[ctx.name].errors == null ? null : _r0.controls[ctx.name].errors.invalidLength);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", _r0.controls[ctx.name] == null ? null : _r0.controls[ctx.name].errors == null ? null : _r0.controls[ctx.name].errors.missingAt);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", _r0.controls[ctx.name] == null ? null : _r0.controls[ctx.name].errors == null ? null : _r0.controls[ctx.name].errors.multipleAt);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", _r0.controls[ctx.name] == null ? null : _r0.controls[ctx.name].errors == null ? null : _r0.controls[ctx.name].errors.invalidCharacters);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", _r0.controls[ctx.name] == null ? null : _r0.controls[ctx.name].errors == null ? null : _r0.controls[ctx.name].errors.missingDomain);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", _r0.controls[ctx.name] == null ? null : _r0.controls[ctx.name].errors == null ? null : _r0.controls[ctx.name].errors.missingDomainExtension);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", _r0.controls[ctx.name] == null ? null : _r0.controls[ctx.name].errors == null ? null : _r0.controls[ctx.name].errors.invalidSpace);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", _r0.controls[ctx.name] == null ? null : _r0.controls[ctx.name].errors == null ? null : _r0.controls[ctx.name].errors.invalidEmail);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", _r0.controls[ctx.name] == null ? null : _r0.controls[ctx.name].errors == null ? null : _r0.controls[ctx.name].errors.duplicateEmail);
    } }, directives: [i1.ɵangular_packages_forms_forms_y, i1.NgControlStatusGroup, i1.NgForm, i2.NgClass, i1.DefaultValueAccessor, i3.EmailValidatorDirective, i1.NgControlStatus, i1.NgModel, i1.RequiredValidator, i2.NgIf], styles: ["input[_ngcontent-%COMP%]:focus {\n  outline: none !important;\n}\n.dnaRComponent[_ngcontent-%COMP%] {\n  display: flex;\n  justify-content: space-between;\n  border: 1px solid #AAAAAA;\n  border-radius: 2px;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0;\n}\n.dnaRComponent[_ngcontent-%COMP%]:hover {\n  border-color: #000000;\n}\n.dnaRComponent[_ngcontent-%COMP%]:focus-within {\n  border-color: #008381;\n}\n.valid[_ngcontent-%COMP%] {\n  border-color: #AAAAAA;\n}\n.invalid[_ngcontent-%COMP%] {\n  border-color: #C53535 !important;\n}\n.dnaRInputContainer[_ngcontent-%COMP%] {\n  display: inline-block;\n}\n.dnaRInput[_ngcontent-%COMP%]   input[_ngcontent-%COMP%] {\n  padding: 5px;\n  height: 32px;\n  outline: none;\n  border: 0;\n  color: #414141;\n  width: 100%;\n}\n.dnaRInput[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder {\n  \n  color: #757575;\n  opacity: 1;\n  \n}\n.dnaRInput[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:-ms-input-placeholder {\n  \n  color: #757575;\n}\n.dnaRInput[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-ms-input-placeholder {\n  \n  color: #757575;\n}\n.dnaRInput[_ngcontent-%COMP%]   .prefix[_ngcontent-%COMP%] {\n  padding: 0 5px;\n  line-height: 32px;\n}\n.dnaRInput[_ngcontent-%COMP%]   .postfix[_ngcontent-%COMP%] {\n  padding: 0 5px;\n  line-height: 32px;\n}\n.dnaRInput.disabled[_ngcontent-%COMP%] {\n  border-color: #D2D2D2;\n  background-color: #F5F5F5;\n  color: #757575;\n}\n.toRight[_ngcontent-%COMP%] {\n  text-align: right;\n}\n.error[_ngcontent-%COMP%] {\n  color: #C53535;\n  float: left;\n  font-size: 12px;\n  padding-bottom: 5px;\n}\n.dnaRComponent[_ngcontent-%COMP%]   input.ng-touched.ng-invalid[_ngcontent-%COMP%]:focus, .ng-submitted[_ngcontent-%COMP%]   .ng-invalid[_ngcontent-%COMP%]:focus, .dnaRComponent[_ngcontent-%COMP%]   input.ng-touched.ng-invalid[_ngcontent-%COMP%], .ng-submitted[_ngcontent-%COMP%]   .ng-invalid[_ngcontent-%COMP%] {\n  box-shadow: none !important;\n}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DnaREmailInput, [{
        type: core_1.Component,
        args: [{
                selector: "dna-r-email-input",
                templateUrl: "./dnaR-email-input.component.html",
                styleUrls: ["./dnaR-email-input.component.less"],
            }]
    }], function () { return []; }, { placeholder: [{
            type: core_1.Input
        }], id: [{
            type: core_1.Input
        }], unique: [{
            type: core_1.Input
        }], name: [{
            type: core_1.Input
        }], value: [{
            type: core_1.Input
        }], required: [{
            type: core_1.Input
        }], class: [{
            type: core_1.Input
        }], saveForm: [{
            type: core_1.Input
        }], requiredFor: [{
            type: core_1.Input
        }], validLength: [{
            type: core_1.Input
        }], totalValidLength: [{
            type: core_1.Input
        }], emailsToCompare: [{
            type: core_1.Input
        }], valueChange: [{
            type: core_1.Output
        }], emailForm: [{
            type: core_1.ViewChild,
            args: ["emailForm"]
        }], childEvent: [{
            type: core_1.Output
        }], triggerUniqueValidation: [{
            type: core_1.Input
        }], triggerCcEmailLengthValidation: [{
            type: core_1.Input
        }] }); })();
